import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    page: {
        backgroundColor: "rgb(210,219,229)",
        height: "100%",
        width: "100%"
    },
    textField: {
        "& .MuiOutlinedInput-input": {
            padding: '10px 14px',
        },
    },
    userName: {
        fontSize: 20,
        fontWeight: "bold"
    },

    circleWrap: {
        width: "122px",
        height: "122px",
        borderRadius: "50%",
        background: "#d2eaf1",
        lineHeight: "120px",
        textAlign: "center",
        marginTop: "14px",
        marginLeft: "14px",
        color: "#1e51dc",
        position: "absolute",
        zIndex: "100",
        fontWeight: "700",
        fontSize: "2em"
    },

    insideCircle: {
        width: "122px",
        height: "122px",
        borderRadius: "50%",
        background: "#d2eaf1",
        lineHeight: "120px",
        textAlign: "center",
        marginTop: "14px",
        marginLeft: "14px",
        color: "#1e51dc",
        position: "absolute",
        zIndex: "100",
        fontWeight: "700",
        fontSize: "2em"
    }


}));


export default useStyles;